export const isWebinarId = (webinarId: string | null | undefined): boolean => {
    if (!webinarId) {
        return false;
    }

    const guidRegex = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;
    return guidRegex.test(webinarId);
};
